// extracted by mini-css-extract-plugin
export default {"box":"be4B5yu6FnPHCJTFw4vd"};